module.exports = __webpack_public_path__ + "img/br36.0f80d53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br36.jpg
// module id = kCk9
// module chunks = 0